export interface ICreateAttributesGroup {
  name: { [key: string]: string };
  description: { [key: string]: string };
  image?: File;
  image_url: string;
  _method: "PUT" | "POST",
  web_selectable: boolean | number,
  web_visible: boolean | number
}
